import { render, staticRenderFns } from "./cgv.vue?vue&type=template&id=6ac43e8a&"
import script from "./cgv.vue?vue&type=script&lang=js&"
export * from "./cgv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports